import { CLIENT_ID } from './constants';
export const APPLICATION_CONFIG = {
    clientId: CLIENT_ID,
    position: 'right',
    align: {
        vertical: 'bottom' /* supported: top, bottom, center */,
        horizontal: 'inner' /* supported: screen_edge, element_edge, inner */,
    },
    widgets: [],
    width: {
        max: 370,
    },
    features: {
        darkTheme: true,
        minibar: false,
        voteEmotions: false,
        commentSentiment: false,
    },
    ux: {
        sidePanel: true,
        pauseTriggers: {
            formOpen: false,
            timelineUgcTap: false,
        },
    },
    margins: {
        top: 0,
        bottom: 0,
        min: 0,
        right: 0,
        left: 0,
        rightSmall: 0,
    },
    demoMode: false,
};
export const WIDGET_CONFIG = {
    player: {
        type: 'custom',
    },
    timeline: {
        embedded: false,
        height: 32,
        overlayVideo: true,
    },
    openOnLoad: false,
};
export const CONTROL_DESCRIPTOR = {
    timeline: {},
    transitions: {},
    height: 60,
    progressBarOffInOverlay: true,
    hideOnPlay: false,
    shownOnLoad: true,
    track: {
        marginRight: 20,
        marginLeft: 20,
        widthPercentage: 100,
    },
    fullScreen: {
        height: 88,
        track: {
            marginRight: 30,
            marginLeft: 30,
            widthPercentage: 100,
        },
    },
    mouse: {
        trackMove: true,
        moveTimeout: 2000,
        hideOnLeave: true,
        showOnEnter: true,
    },
};
//# sourceMappingURL=config.js.map